import React from "react";
import { useTranslation } from "react-i18next";
import CompanyField from "../company/CompanyField";
import { MAX_EMAIL, MAX_PERSON_NAME, MAX_PHONE } from "../../lib/platformValidation";

/**
 * The four Owner contact fields, shared by creation and Owner replacement so the
 * two surfaces cannot drift apart.
 *
 * The e-mail address decides everything downstream: the database itself derives
 * whether this is a NEW OfferTrace user (Supabase Admin invitation) or an
 * EXISTING one (a security e-mail with a one-time token), so the console never
 * asks and never probes whether an account exists.
 */
export const PlatformOwnerFields = ({ idPrefix, draft, errors, disabled, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className="qw-grid cols-2">
      <CompanyField
        id={`${idPrefix}-first-name`}
        testId={`${idPrefix}-first-name`}
        label={t("platform.owner_first_name")}
        value={draft.owner_first_name}
        onChange={(v) => onChange("owner_first_name", v)}
        error={errors.owner_first_name}
        disabled={disabled}
        maxLength={MAX_PERSON_NAME}
        required
      />
      <CompanyField
        id={`${idPrefix}-last-name`}
        testId={`${idPrefix}-last-name`}
        label={t("platform.owner_last_name")}
        value={draft.owner_last_name}
        onChange={(v) => onChange("owner_last_name", v)}
        error={errors.owner_last_name}
        disabled={disabled}
        maxLength={MAX_PERSON_NAME}
        required
      />
      <CompanyField
        id={`${idPrefix}-email`}
        testId={`${idPrefix}-email`}
        label={t("platform.owner_email")}
        type="email"
        value={draft.owner_email}
        onChange={(v) => onChange("owner_email", v)}
        error={errors.owner_email}
        help={t("platform.owner_email_help")}
        disabled={disabled}
        maxLength={MAX_EMAIL}
        required
      />
      <CompanyField
        id={`${idPrefix}-phone`}
        testId={`${idPrefix}-phone`}
        label={t("platform.owner_phone")}
        value={draft.owner_phone}
        onChange={(v) => onChange("owner_phone", v)}
        error={errors.owner_phone}
        help={t("platform.owner_phone_help")}
        disabled={disabled}
        maxLength={MAX_PHONE}
      />
    </div>
  );
};

export default PlatformOwnerFields;
